
























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import SuporteFornecedoresStore from '@/components/Suporte/Store/SuporteFornecedoresStore'
import { DataTablePagination } from '@/types/_'
import { useHospitais } from '@/composables'

@Component
export default class ViewSuporteFornecedores extends Vue {
  loadFornecedores: boolean = false
  loadAddFornecedores: boolean = false
  loadEditFornecedores: string = ''

  get getSuporteFornecedoresStore() {
    return getModule(SuporteFornecedoresStore, this.$store)
  }

  get paginationFornecedor() { return this.getSuporteFornecedoresStore.paginationFornecedor }

  get loadingFornecedores() { return this.loadFornecedores }
  set loadingFornecedores(value: boolean) { this.loadFornecedores = value }
  get loadingAddFornecedores() { return this.loadAddFornecedores }
  set loadingAddFornecedores(value: boolean) { this.loadAddFornecedores = value }
  get loadingEditFornecedores() { return this.loadEditFornecedores }
  set loadingEditFornecedores(value: string) { this.loadEditFornecedores = value }

  get hospitalId() { return this.getSuporteFornecedoresStore.hospitalId }
  set hospitalId(value: string) { this.getSuporteFornecedoresStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get fornecedoresHeaders() {
    return [
      { text: 'Nome', value: 'nome', sortable: false },
      { text: 'HisId', value: 'hisId', sortable: false },
      { text: 'E-mail', value: 'email', sortable: false },
      { text: 'Fabricante', value: 'fabricante', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get fornecedores() { return this.getSuporteFornecedoresStore.fornecedores }
  get searchFornecedor() { return this.getSuporteFornecedoresStore.searchFornecedor }
  set searchFornecedor(value: string) { this.getSuporteFornecedoresStore.setSearchFornecedor(value) }

  @Watch('searchFornecedor')
  async onChangeSearchFornecedor(value: any) {
    this.fornecedorPagedDebounce({ ...this.paginationFornecedor })
  }

  async hospitalChange(id: any) {
    this.getSuporteFornecedoresStore.clearSearchFornecedor()
    this.getSuporteFornecedoresStore.setHospitalId(id)

    const params: any = { hospitalId: id, ...this.getSuporteFornecedoresStore.paginatioDefault }

    this.loadingFornecedores = true
    await this.getSuporteFornecedoresStore.getFornecedorPagedSearch(params)
    this.loadingFornecedores = false
  }

  fornecedorPagedDebounce = _.debounce(param => this.getSuporteFornecedoresStore.getFornecedorPagedSearch(param), 700)

  async updatePaginationFornecedores(pagination: DataTablePagination) {
    if (['', null, undefined].includes(this.hospitalId)) return
    this.loadingFornecedores = true
    this.fornecedorPagedDebounce(pagination)
    this.loadingFornecedores = false
  }

  adicionarFornecedor() {
    this.getSuporteFornecedoresStore.setMode({ modal: 'fornecedor', mode: 'CREATE' })
    this.getSuporteFornecedoresStore.clearFornecedor()
    this.getSuporteFornecedoresStore.setModal({ name: 'fornecedor', value: true })
  }

  async editarFornecedor(item: any) {
    this.loadingEditFornecedores = item.fornecedorId
    this.getSuporteFornecedoresStore.setMode({ modal: 'fornecedor', mode: 'EDIT' })
    this.getSuporteFornecedoresStore.setFornecedor({ ...item })
    this.getSuporteFornecedoresStore.setModal({ name: 'fornecedor', value: true })
    this.loadingEditFornecedores = ''
  }

  beforeDestroy() {
    this.getSuporteFornecedoresStore.clearFornecedores()
    this.getSuporteFornecedoresStore.clearHospitalId()
  }
}
